// the default style follows figma and adwords
// https://www.figma.com/file/UiSbekGiA9XqEL6WM2v5allf/Bing-Ads-HIG-0.01.01?node-id=0%3A8166
const theme = {
  minWidth: '100px',
  fontSize: '14px',
};

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export const getStatusDropdownStyles = ({ statusDropdown = {} }, { palette = {} }) => ({
  statusDropdown: {
    '& .status-dropdown': {
      position: 'relative',
      minWidth: theme.minWidth,
    },
    '& .dropdown-toggle[disabled]': {
      cursor: 'default',
    },
    '& .dropdown-toggle': {
      display: 'flex',
      flexDirection: 'column',
      border: 'none',
      fontWeight: 'normal',
      fontSize: theme.fontSize,
      backgroundColor: palette.neutralLighter,
      '& > div': {
        display: 'flex',
        justifyContent: 'space-between',
        '& > div': {
          display: 'flex',
        },
      },
      '& .overflow-status-text': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      '& .status-icon': {
        flexShrink: 0,
      },
    },
    '& .dropdown-toggle:focus': {
      outline: 'none',
    },
    '& .icon-status-draft, & .icon-status-expired, & .icon-status-paused': {
      marginRight: '5px',
      fontSize: theme.fontSize,
    },
    '& .icon-status-expired': {
      color: '#CF2837',
    },
    '& .icon-status-active': {
      marginRight: '5px',
      fontSize: theme.fontSize,
      color: '#107C10',
    },
    '& .dropdown-menu': {
      minWidth: theme.minWidth,
    },
    '& .list-selector-item': {
      display: 'block',
      padding: '7px 10px',
      clear: 'both',
      fontSize: theme.fontSize,
      fontWeight: 'normal',
      color: palette.neutralDark,
      whiteSpace: 'nowrap',
    },
    '& .list-selector-item:hover': {
      textDecoration: 'none',
      backgroundColor: palette.neutralLighter,
    },
    '& .dropdown-menu .selected': {
      backgroundColor: palette.neutralLighter,
    },
    '& .icon-ChevronDown': {
      margin: '4px 10px',
      color: palette.neutralSecondary,
      fontSize: '12px',
    },
  },
});
